import React, { FunctionComponent, useEffect, useState } from "react";

import buildCache, { JobCache } from "./cache";
import type { ListCliOptions, RunCliOptions } from "./cli";
import Console from "./console";
import JobList from "./list";
import Run from "./runner";

const useJobCache = (pattern: string | string[]) => {
	const [cache, setCache] = useState<JobCache>();

	useEffect(() => {
		void buildCache(pattern).then(setCache);
	}, [pattern]);

	return cache;
};

interface CommandProps {
	cache: JobCache;
	command: string;
	opts: RunCliOptions | ListCliOptions;
}

const Command: FunctionComponent<CommandProps> = ({ cache, command, opts }) => {
	switch (command) {
		case "run":
			return <Run cache={cache} config={opts as RunCliOptions} />;

		case "list":
			return <JobList cache={cache} opts={opts as ListCliOptions} />;

		default:
			return null;
	}
};

interface AppProps {
	pattern?: string[] | string;
	command: string;
	opts: RunCliOptions | ListCliOptions;
}

const App: FunctionComponent<AppProps> = ({ pattern, ...props }) => {
	const cache = useJobCache(pattern);

	if (!cache) {
		return null;
	}

	return (
		<Console>
			<Command {...props} cache={cache} />
		</Console>
	);
};

export default App;
